import { lazy, useContext } from "react";



const Administration = lazy(() => import("./Administration"));

const RhEdit = lazy(() => import("./Rh/RhEdit"));

const Rh = lazy(() => import("./Rh/Rh"));

const SectionEdit = lazy(() => import("./Section/SectionEdit"));

const GradeEdit = lazy(() => import("./Grade/GradeEdit"));

const OtherCompanyEdit = lazy(() => import("./OtherCompany/OtherCompanyEdit"));

const ClientForm = lazy(() => import("./CustomForms/ClientForm"));

const FournisseurForm = lazy(() => import("./CustomForms/FournisseurForm"));

const MarqueForm = lazy(() => import("./CustomForms/MarqueForm"));

const ArticleForm = lazy(() => import("./CustomForms/ArticleForm"));

const PurchaseOrderForm = lazy(() => import("./CustomForms/PurchaseOrderForm"));

const ShipmentForm = lazy(() => import("./CustomForms/ShipmentForm"));

const TransferOrderForm = lazy(() => import("./CustomForms/TransferOrderForm"));

const SalesOrderForm = lazy(() => import("./CustomForms/SalesOrderForm"));

const StockEdit = lazy(() => import("./Section/StockEdit"));

const EcommerceProfil = lazy(() => import("./Ecommerce/EcommerceProfil"));

const CarrePosProfil = lazy(() => import("./CarrePos/CarrePosProfil"));

const ClientList = lazy(() => import("./Client/ClientList"));

const ClientEdit = lazy(() => import("./Client/ClientEdit"));

const CustomizedItem = lazy(() => import("./CustomizedInterface/CustomizedItem"));

const CustomizedPo = lazy(() => import("./CustomizedInterface/CustomizedPo"));

const CustomizedShipment = lazy(() => import("./CustomizedInterface/CustomizedShipment"));

const CustomizedProviders = lazy(() => import("./CustomizedInterface/CustomizedProviders"));

const CustomizedRppsl = lazy(() => import("./CustomizedInterface/CustomizedRppsl"));

const CustomizedTo = lazy(() => import("./CustomizedInterface/CustomizedTo"));

const CustomizedEtiquette = lazy(() => import("./CustomizedInterface/CustomizedEtiquette"));

const CustomizedRaccourci = lazy(() => import("./CustomizedInterface/CustomizedRaccourci"));

const CustomizedKpi = lazy(() => import("./CustomizedInterface/CustomizedKpi"));

const Bins = lazy(() => import("./Bins/Bins"));

const GenerateAllBinsBarCode = lazy(() => import("./Bins/GenerateAllBinsBarCode"));

const NotificationListAdmin = lazy(() => import("./Notification/NotificationListAdmin"));

const NotificationDetailAdmin = lazy(() => import("./Notification/NotificationDetailAdmin"));

const LicenceNotificationDetail = lazy(() => import("../notifications/LicenceNotificationDetail"));

const HistoriqueDetail = lazy(() => import("./Historique/HistoriqueDetail"));

const ReportPbiConfiguration = lazy (() => import("./ReportPbi/ReportPbiConfiguration"));

const ExportPbiDatasConfiguration = lazy (() => import("./ReportPbi/ExportPbiDatasConfiguration"));

const AccessConfiguration = lazy (() => import("./AccessConfiguration/AccessConfiguration"));

const TestEtiquette = lazy (() => import("./Etiquette/TestEtiquette"));

const MiseEnPage = lazy (() => import("./Facturation/MiseEnPage"));

const ModelEmail = lazy (() => import("./Facturation/ModelEmail"));

const Divers = lazy (() => import("./Facturation/Divers"));

const InfosSuppArticle = lazy (() => import("./Facturation/InfosSuppArticle"));

const EmetteurClient = lazy (() => import("./Facturation/EmetteurClient"));

const CodeConfiguration = lazy (() => import("./Comptabilite/CodeConfiguration"));

const FileConfiguration = lazy (() => import("./Comptabilite/FileConfiguration"));

const AutoExportConfiguration = lazy (() => import("./Comptabilite/AutoExportConfiguration"));

const SalesJournalConfB2c = lazy (() => import("./Comptabilite/JournalVenteConfig/SalesJournalConfB2c"));



const administrationRoutes = [
    // ─── Administration générale ───────────────────────────────────────────────
    {
        path: "/administration/welcome",
        id: "admin_welcome",
        name: "[Configuration] Administration générale - /administration/welcome",
        component: Administration
    },
    {
        path: "/administration/section/:id",
        id: "admin_section",
        name: "[Configuration] Édition d'une section - /administration/section/:id",
        component: SectionEdit
    },
    {
        path: "/administration/zone/:id",
        id: "admin_zone",
        name: "[Configuration] Édition d'une zone de stock - /administration/zone/:id",
        component: StockEdit
    },
    {
        exact:true,
        path: "/administration/bins/:sectionId/:zoneid",
        id: "admin_bins",
        name: "[Configuration] Bins d'une zone - /administration/bins/:sectionId/:zoneid",
        component: Bins
    },
    {
        path: "/administration/bins/:zoneid/bar-code-pdf/:first/:second/:third/:fourth/:fifth",
        id: "admin_bins_barcode_pdf",
        // name: "[Configuration] Codes-barres des bins (PDF) - /administration/bins/:zoneid/bar-code-pdf/:first/:second/:third/:fourth/:fifth",
        component: GenerateAllBinsBarCode
    },
    {
        path: "/administration/grade/:id",
        id: "admin_grade",
        name: "[Configuration] Édition d'un grade - /administration/grade/:id",
        component: GradeEdit
    },
    {
        path: "/administration/othercompany/:id",
        id: "admin_othercompany",
        name: "[Configuration] Édition d'une autre société - /administration/othercompany/:id",
        component: OtherCompanyEdit
    },
    {
        path: "/administration/e-commerce/:id",
        id: "admin_ecommerce",
        // name: "[Configuration] Profil e-commerce - /administration/e-commerce/:id",
        component: EcommerceProfil
    },
    {
        path: "/administration/carrepos/:id",
        id: "admin_carrepos",
        // name: "[Configuration] Profil CarréPOS - /administration/carrepos/:id",
        component: CarrePosProfil
    },
    // ─── Personnel ─────────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/administration/rh",
        id: "admin_rh",
        name: "[Configuration] Liste du personnel - /administration/rh",
        component: Rh
    },
    {
        path: "/administration/rh/edit/:id",
        id: "admin_rh_edit",
        name: "[Configuration] Édition d'un membre du personnel - /administration/rh/edit/:id",
        component: RhEdit
    },
    // ─── Formulaires personnalisés ─────────────────────────────────────────────
    {
        path: "/administration/customforms/article",
        id: "admin_customforms_article",
        name: "[Configuration] Formulaire personnalisé - article - /administration/customforms/article",
        component: ArticleForm
    },
    {
        path: "/administration/customforms/fournisseur",
        id: "admin_customforms_fournisseur",
        name: "[Configuration] Formulaire personnalisé - fournisseur - /administration/customforms/fournisseur",
        component: FournisseurForm
    },
    {
        path: "/administration/customforms/marque",
        id: "admin_customforms_marque",
        name: "[Configuration] Formulaire personnalisé - marque - /administration/customforms/marque",
        component: MarqueForm
    },
    {
        path: "/administration/customforms/client",
        id: "admin_customforms_client",
        name: "[Configuration] Formulaire personnalisé - client - /administration/customforms/client",
        component: ClientForm
    },
    {
        path: "/administration/customforms/bon-de-commande",
        id: "admin_customforms_purchase_order",
        name: "[Configuration] Formulaire personnalisé - bon de commande - /administration/customforms/bon-de-commande",
        component: PurchaseOrderForm
    },
    {
        path: "/administration/customforms/shipment",
        id: "admin_customforms_shipment",
        name: "[Configuration] Formulaire personnalisé - bon d'expédition - /administration/customforms/shipment",
        component: ShipmentForm
    },
    {
        path: "/administration/customforms/to",
        id: "admin_customforms_to",
        name: "[Configuration] Formulaire personnalisé - ordre de transfert - /administration/customforms/to",
        component: TransferOrderForm
    },
    {
        path: "/administration/customforms/commande-client",
        id: "admin_customforms_sales_order",
        name: "[Configuration] Formulaire personnalisé - commande client - /administration/customforms/commande-client",
        component: SalesOrderForm
    },
    // ─── Clients (entrée de menu actuellement commentée) ───────────────────────
    {
        exact:true,
        path: "/administration/client",
        id: "admin_client",
        // name: "[Configuration] Liste des clients - /administration/client",
        component: ClientList
    },
    {
        path: "/administration/client/edit/:id",
        id: "admin_client_edit",
        // name: "[Configuration] Édition d'un client - /administration/client/edit/:id",
        component: ClientEdit
    },
    // ─── Interface personnalisée ───────────────────────────────────────────────
    {
        path: "/administration/customization/item",
        id: "admin_customization_item",
        name: "[Configuration] Interface personnalisée - articles - /administration/customization/item",
        component: CustomizedItem
    },
    {
        path: "/administration/customization/bon-de-commande",
        id: "admin_customization_purchase_order",
        name: "[Configuration] Interface personnalisée - bons de commande - /administration/customization/bon-de-commande",
        component: CustomizedPo
    },
    {
        path: "/administration/customization/shipment-voucher",
        id: "admin_customization_shipment",
        name: "[Configuration] Interface personnalisée - bons d'expédition - /administration/customization/shipment-voucher",
        component: CustomizedShipment
    },
    {
        path: "/administration/customization/providers",
        id: "admin_customization_providers",
        name: "[Configuration] Interface personnalisée - fournisseurs - /administration/customization/providers",
        component: CustomizedProviders
    },
    {
        path: "/administration/customization/rppsl",
        id: "admin_customization_rppsl",
        name: "[Configuration] Interface personnalisée - RPPSL - /administration/customization/rppsl",
        component: CustomizedRppsl
    },
    {
        path: "/administration/customization/to",
        id: "admin_customization_to",
        name: "[Configuration] Interface personnalisée - ordres de transfert - /administration/customization/to",
        component: CustomizedTo
    },
    {
        path: "/administration/customization/checkout-shortcut",
        id: "admin_customization_checkout_shortcut",
        name: "[Configuration] Interface personnalisée - raccourcis de caisse - /administration/customization/checkout-shortcut",
        component: CustomizedRaccourci
    },
    {
        path: "/administration/customization/kpi",
        id: "admin_customization_kpi",
        name: "[Configuration] Interface personnalisée - filtres KPI - /administration/customization/kpi",
        component: CustomizedKpi
    },
    {
        path: "/administration/customization/etiquette",
        id: "admin_customization_etiquette",
        name: "[Configuration] Interface personnalisée - étiquettes - /administration/customization/etiquette",
        component: CustomizedEtiquette
    },
    {
        exact:true,
        path: "/administration/etiquette/test",
        id: "admin_etiquette_test",
        // name: "[Configuration] Test d'étiquette - /administration/etiquette/test",
        component: TestEtiquette
    },
    // ─── Facturation ───────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/administration/facturation/layout",
        id: "admin_facturation_layout",
        name: "[Configuration] Facturation - mise en page - /administration/facturation/layout",
        component: MiseEnPage
    },
    {
        exact:true,
        path: "/administration/facturation/email_layout",
        id: "admin_facturation_email_layout",
        name: "[Configuration] Facturation - modèle d'email - /administration/facturation/email_layout",
        component: ModelEmail
    },
    {
        exact:true,
        path: "/administration/facturation/divers",
        id: "admin_facturation_divers",
        name: "[Configuration] Facturation - divers - /administration/facturation/divers",
        component: Divers
    },
    {
        exact:true,
        path: "/administration/facturation/informations_article",
        id: "admin_facturation_infos_article",
        name: "[Configuration] Facturation - informations sur la ligne article - /administration/facturation/informations_article",
        component: InfosSuppArticle
    },
    {
        exact:true,
        path: "/administration/facturation/emetteur_client",
        id: "admin_facturation_emetteur_client",
        name: "[Configuration] Facturation - émetteur client - /administration/facturation/emetteur_client",
        component: EmetteurClient
    },
    // ─── Rapports Power BI ─────────────────────────────────────────────────────
    {
        exact:true,
        path: "/administration/report/export_datas",
        id: "admin_report_export_datas",
        name: "[Configuration] Export des données - /administration/report/export_datas",
        component: ExportPbiDatasConfiguration
    },
    {
        path: "/administration/report/configuration",
        id: "admin_report_configuration",
        // name: "[Configuration] Configuration des rapports Power BI - /administration/report/configuration",
        component: ReportPbiConfiguration
    },
    // ─── Accès ─────────────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/administration/access-configuration",
        id: "admin_access_configuration",
        name: "[Configuration] Configuration des accès - /administration/access-configuration",
        component: AccessConfiguration
    },
    // ─── Comptabilité ──────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/administration/comptabilite/configuration-code",
        id: "admin_comptabilite_code",
        name: "[Configuration] Comptabilité - configuration des codes - /administration/comptabilite/configuration-code",
        component: CodeConfiguration
    },
    {
        exact:true,
        path: "/administration/comptabilite/configuration-file",
        id: "admin_comptabilite_file",
        name: "[Configuration] Comptabilité - configuration du fichier - /administration/comptabilite/configuration-file",
        component: FileConfiguration
    },
    {
        exact:true,
        path: "/administration/comptabilite/configuration-automatic-export",
        id: "admin_comptabilite_auto_export",
        name: "[Configuration] Comptabilité - export automatique - /administration/comptabilite/configuration-automatic-export",
        component: AutoExportConfiguration
    },
    {
        exact:true,
        path: "/administration/comptabilite/configuration-sales-journal/b2c",
        id: "admin_comptabilite_sales_journal_b2c",
        name: "[Configuration] Comptabilité - journal des ventes B2C - /administration/comptabilite/configuration-sales-journal/b2c",
        component: SalesJournalConfB2c
    },
    // ─── Notifications & historique (hors menu) ────────────────────────────────
    {
        path: "/administration/notifications/list",
        id: "admin_notifications_list",
        // name: "[Configuration] Liste des notifications - /administration/notifications/list",
        component: NotificationListAdmin
    },
    {
        path: "/administration/notifications/detail/:id",
        id: "admin_notifications_detail",
        // name: "[Configuration] Détail notification - /administration/notifications/detail/:id",
        component: NotificationDetailAdmin
    },
    {
        path: "/administration/notifications/licence-notification/:licenceNotificationId",
        id: "admin_notifications_licence_detail",
        // name: "[Configuration] Détail notification licence - /administration/notifications/licence-notification/:licenceNotificationId",
        component: LicenceNotificationDetail
    },
    {
        path: "/administration/historique/edit/:id",
        id: "admin_historique_edit",
        // name: "[Configuration] Détail historique - /administration/historique/edit/:id",
        component: HistoriqueDetail
    },
];

export default administrationRoutes;
